import { render, staticRenderFns } from "./RecipeAdd3.vue?vue&type=template&id=bd4e9d46&scoped=true&"
import script from "./RecipeAdd3.vue?vue&type=script&lang=js&"
export * from "./RecipeAdd3.vue?vue&type=script&lang=js&"
import style0 from "./RecipeAdd3.vue?vue&type=style&index=0&id=bd4e9d46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4e9d46",
  null
  
)

export default component.exports